import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import CollapsibleItems from '../../components/shared/CollapsibleItems';

const MAIN_TRUST_ITEMS = [
  {
    title: 'Your home, your data.',
    content:
      'You’re in control of the personal data you provide, either directly or through a 3rd party. By using HOVER, you give us permission to do certain things with your data so we can run our service. Some of these operations may require us to send your data to our business partners — such as a cloud storage provider — that we’ve contracted with to provide parts of the HOVER Service. Before we do this, we’ll always make sure that our contracts with such partners protect your data rights.',
  },
  {
    title: 'Transparency is the cornerstone of trust.',
    content:
      'We will be transparent about data collection and its use so you can make informed decisions. We will hold our partners and Customers accountable to ensure that 3rd parties that use HOVER to provide you services adhere to our privacy policies and terms of use. We will protect the data you entrust to us with strong security and encryption.',
  },
  {
    title: 'Your choices matter.',
    content:
      'Whether you come to HOVER on your own or through a 3rd party, we’ll respect your choice of who has access to your personal data. You can provide or revoke access to any 3rd party, through your HOVER settings.',
  },
];

const IntroSection = () => (
  <Box>
    <Text>
      At HOVER, we are on a mission to organize the world’s physical structure
      and we are a trusted provider for homeowners, our customers, and within
      our partner ecosystem. To do this, we commit to communicate transparently,
      provide security, and protect the privacy of the data within HOVER’s
      systems.
    </Text>
    <CollapsibleItems items={MAIN_TRUST_ITEMS} />
  </Box>
);

export default IntroSection;
